import { Component, inject, model } from '@angular/core';
import { BranchesService } from '../services/branches.service';
import { BranchModel } from '../../shared/models/branch.model';
import { ActivatedRoute } from '@angular/router';
import { BranchesFormComponent } from "../branches-form/branches-form.component";
import { AccessService } from '../../core/services/access.service';

@Component({
  selector: 'app-branches-edit',
  standalone: true,
  imports: [BranchesFormComponent],
  templateUrl: './branches-edit.component.html',
  styleUrl: './branches-edit.component.css'
})
export class BranchesEditComponent {
  private route = inject(ActivatedRoute)
  private service = inject(BranchesService)

  protected access = inject(AccessService).access
  protected id!: string | null;

  protected value = model<BranchModel | undefined>(undefined)
  ngOnInit(): void {
    this.service.title.update((value) => 'Detalles de la Sucursal')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.getBranch(params.get('id'));
    });
  }

  getBranch(id: string | null) {
    console.log('get branch', id)
    if (id === null) {
      this.value.update((value) => (value = undefined));
    } else {
      // this.userService.userDetailed(userId);
      this.service.get(id).subscribe(data => {
        console.log('Sucursal: ', data)
        this.value.update(value => (value = data as BranchModel));
      });
    }
  }
}
